import type { EmailMetadataView } from '@/lib/message-metadata';
import { Text } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

interface EmailRailNoteProps {
  metadata: EmailMetadataView | undefined;
}

/**
 * Says which address a flow email left from when it is not the usual Fluenceur one:
 * the creator's mailbox, or Fluenceur's address because that mailbox could not send.
 * An email sent the usual way shows nothing.
 */
export function EmailRailNote({ metadata }: EmailRailNoteProps) {
  const { t } = useTranslation();

  if (metadata?.sentVia === 'mailbox' && metadata.senderEmail) {
    return (
      <Text fontSize="xs" color="gray.600">
        {t('messages.email.sentFromMailbox', { email: metadata.senderEmail })}
      </Text>
    );
  }

  if (metadata?.mailboxFallback) {
    return (
      <Text fontSize="xs" color="gray.500">
        {t('messages.email.mailboxFallback')}
      </Text>
    );
  }

  return null;
}
